import { combineReducers } from 'redux';
import { fetchTransporterDeliveryConfirmation } from './redTransporter-DeliveryConfirmationDetails.jsx';
import { fetchDeliveryStatusList } from './redTransporter-DeliveryStatusList.jsx';
import { fetchTransporterShareTrack } from './redTransporter-ShareTracker.jsx';
import { fetchWoUploadedImage, fetchWoDriverList } from './redTransporter-WorkOrdersUpload'
import { fetchCompanyList } from './redUser-CompanyList'
import { StckMasterOutbound } from './stck.masteroutboundwithItem.red'
import { fetchSettingList } from './redUser-SettingList.jsx';
import { woInboundItemDetail, woOtuboundItemDetail } from './redTransporter-WoStocker';
import { fetchTrackAndTraceList } from './redTransporter-TrackAndTrace.jsx'

const rootReducer = combineReducers({
    transporterShareTrackStore: fetchTransporterShareTrack,
    transporterDeliveryConfirmationDetailsStore: fetchTransporterDeliveryConfirmation,
    deliveryStatusListStore: fetchDeliveryStatusList,
    woUploadedImageStore: fetchWoUploadedImage,
    woDriverListStore : fetchWoDriverList,
    woInboundItemDetailStore: woInboundItemDetail,
    woOtuboundItemDetailStore: woOtuboundItemDetail,

    companyList: fetchCompanyList,
    settingStore: fetchSettingList,

    masterOutboundStore: StckMasterOutbound,
    trackAndTraceStore: fetchTrackAndTraceList
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx